import React from 'react';
import './StatusChip.scss';

export default function StatusChip({ status, labels = { true: 'Active', false: 'Disabled' } }) {
  return (
    <span className={`admin-status-chip ${status ? 'active' : 'disabled'}`}>{status ? labels.true : labels.false}</span>
  );
}
